module.exports = __webpack_public_path__ + "img/cases-brand-zedriv-6.06a2f95c.png";